export const environment = {
    'api_url': 'https://connect.uitgeverijneo.dev/api',
    'issuer': 'https://connect.uitgeverijneo.dev',
    'redirect_uri': 'https://office.uitgeverijneo.dev/callback',
    'client_id': '9d2203f9-d8df-4546-8eae-21fa4441b88e',
    'login_url': 'https://connect.uitgeverijneo.dev/oauth/authorize',
    'token_endpoint': 'https://connect.uitgeverijneo.dev/oauth/token',
    'userinfo_endpoint': 'https://connect.uitgeverijneo.dev/api/me',

    production: false
};
